/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { useEffect } from "react";
import { reportClientErrorAsync, GlobalErrorHandler } from "@cosmos/next-common";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}): React.JSX.Element {
	console.log(error);

	useEffect(() => {
		const errorWithContext = {
			...error,
			errorBoundary: "root-level",
			message: error.message,
			stack: error.stack,
			cause: error.cause,
			digest: error.digest,
			name: error.name,
		};
		void reportClientErrorAsync(errorWithContext);
	}, [error]);

	return (
		<html>
			<body>
				<GlobalErrorHandler />
				<h2>Something went wrong!</h2>
				<button onClick={() => reset()}>Try again</button>
			</body>
		</html>
	);
}
